import React from 'react';
import { PropTypes } from 'prop-types';

const Description = ({ className, t }) => (
  <div className={className}>
    <p>{t('discardReasons.description1')}.</p>
    <p>{t('discardReasons.description2')}.</p>
    <p>{t('discardReasons.description3')}.</p>
  </div>
);

Description.propTypes = {
  t: PropTypes.func,
  className: PropTypes.string,
};

Description.defaultProps = {
  t: (t) => t,
  className: '',
};

export default Description;
